import './CaseStudyItems.scss';

class CaseStudyItems {

  constructor(node) {
    this.node = node;
  }

  init() {
    //console.log();
  }

}

JSModules['CaseStudyItems'] = CaseStudyItems;
export default CaseStudyItems;
